import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class SuccessMsg {
    show = false;
    text = '';
    notificationType = "";
    crewName = "";
    delay = 3000;

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);

        this.rootStore = rootStore;
    }

    showNotification(text: string, crew: string, notificationType: string, delay: number) {
        this.show = true;
        this.text = text;
        this.notificationType = notificationType;
        this.crewName = crew;
        this.delay = delay;
      }

    resetNotification() {
    this.show = false;
    }

    handleShow = (a: boolean) =>  {
        this.show = a;
    }

    get getShow() {
        return this.show;
    }
    get getText() {
        return this.text;
    }
    get getNotificationType() {
        return this.notificationType;
    }
    get getCrewName() {
        return this.crewName;
    }
}